export { default, styleFunction } from './Box';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Box/index.js
// module id = 641
// module chunks = 0